/* file description */
import { UseGetBindLabel } from './type';
import { useEffect, useState } from 'react';
import { getModuleRecordList } from '@/common/asset-apis/assetModel';
import { getPinyin, getFirstPinyin } from './pinyinUtil';
import { COLUMN_FROM } from '../../../effects/consts';

export const useGetBindLabel: UseGetBindLabel = ({ field, API, form, config, columnFrom, moduleInfo, fieldValue, onChange }) => {
  const { dispatchEvent, destroyEvent } = config.metaStore || {};
  const [parentValue, setparentValue] = useState('');
  const [bindData, setBindData] = useState<any[]>([]);
  const { isBindLabel, labelBindKey, labelModule, dataKey, treeId, bindId, value, labelBindLabel, parentName, parentField } = field?.options || {};

  // let parentValue: string | undefined;
  // if (columnFrom === COLUMN_FROM.TABLE) {
  //   if (form.getFieldsValue()[config.rowIndex]) {
  //     parentValue = form.getFieldsValue()[config.rowIndex][field?.options?.parentField];
  //   }
  // } else {
  //   parentValue = form.getFieldsValue()[field?.options?.parentField];
  // }

  useEffect(() => {
    if (isBindLabel && parentField) {
      let pvalue: string | undefined;
      if (columnFrom === COLUMN_FROM.TABLE) {
        if (config.formValue[config.rowIndex]) {
          pvalue = config.formValue[config.rowIndex][parentField];
        }
      } else {
        pvalue = config.formValue[parentField];
      }
      setparentValue(pvalue);
      const events = [{
        code: field.name,
        name: field.label,
        touchConfig: 'change',
        actionType: 'callback',
        moduleName: moduleInfo.handle,
        fieldName: parentField,
        rowIndex: config.rowIndex,
        fun: (value: any) => {
          setparentValue(value);
        },
      }];
      const ids = dispatchEvent?.(events);
      return () => {
        destroyEvent?.(ids);
      };
    }
  }, []);


  // useEffect(() => {
  //   if (isBindLabel && parentField) {
  //     let pvalue: string | undefined;
  //     if (columnFrom === COLUMN_FROM.TABLE) {
  //       if (form.getFieldsValue()[config.rowIndex]) {
  //         pvalue = form.getFieldsValue()[config.rowIndex][parentField];
  //       }
  //     } else {
  //       pvalue = form.getFieldsValue()[parentField];
  //     }
  //     setparentValue(pvalue);
  //     // if (pvalue !== parentValue) {
  //     //   setparentValue(pvalue);
  //     // }
  //   }
  // });

  const convert = (data: any) => {
    const obj: Record<any, any> = {}
    data.values && data.values.forEach((item: any) => {
      obj[item.name] = item.value
    })
    return obj
  }

  useEffect(() => {
    if (isBindLabel) {
      if (parentField && parentName && !parentValue) {
        return;
      }
      // 查询关联模型列表
      getModuleRecordList(
        API?.FetchAPI,
        treeId,
        dataKey,
        {
          moduleID: dataKey,
          namespaceID: treeId,
          filter: parentValue ? `${parentName} = '${parentValue}'` : ''
        }
      ).then(res => {
        let valueList: any[] = []
        res.set.forEach((item: any) => {
          valueList.push(item.values.find((data: any) => data.name === value)?.value)
        })
        valueList = [...new Set(valueList)]
        if (valueList.length > 0) {
          // 通过关联模型数据匹配基本信息列表
          const targetSql = valueList.map((fV) => `'${fV}'`).join(',');
          getModuleRecordList(
            API?.FetchAPI,
            bindId || treeId,
            labelModule,
            {
              moduleID: labelModule,
              namespaceID: bindId || treeId,
              filter: `${labelBindKey} in (${targetSql})`,
            }
          ).then(response => {
            const mapData = response.set.map((item: any) => {
              const { values = [] } = item || {};
              const converData = convert(item)
              const tLabel = values.find((v: any) => v.name === labelBindLabel)?.value;
              const tValue = values.find((v: any) => v.name === labelBindKey)?.value;
              const fullPY = getPinyin(tLabel)
              const firstPY = getFirstPinyin(tLabel)
              return {
                ...converData,
                label: tLabel,
                value: tValue,
                fullPY,
                firstPY
              };
            });
            setBindData(mapData)
          })
        } else {
          setBindData([]);
        }
      })
    }
  }, [parentValue]);

  return {
    bindData,
  };
};
